import styled from 'styled-components';
import { Typography } from '../../styles';

export const Svg = styled.svg`
    ${Typography.Desktop['H80-B']}
    display: block;
    fill: currentColor;
`;
